import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AccountTransfersCollection } from '../../Models/Domains/Transactions/AccountTransfers/AccountTransfersCollection';
import { IJsonDate } from '../../System/IJsonDate';
import { AccountTransfersSort } from '../../Models/Domains/Transactions/AccountTransfers/AccountTransfersSort';

declare var IS_RUNNING_IN_APP_POOL;

export class AccountTransfersClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, fromDate: IJsonDate, toDate: IJsonDate, fromInception: boolean, minrow: number, maxrow: number, sortby: AccountTransfersSort, sortByAscending: boolean): Promise<AccountTransfersCollection, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transaction/AccountTransfers/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, fromDate: fromDate, toDate: toDate, fromInception: fromInception, minrow: minrow, maxrow: maxrow, sortby: sortby, sortByAscending: sortByAscending }

    return AjaxWrapper.get<AccountTransfersCollection, any>(url, data);
  }
}

